import React from "react";
import { observer } from "mobx-react";
import { TenantPlanUpdateStore } from "../../store";
import { TenantPlanUpdateForm } from "./TenantPlanUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type TenantPlanUpdateProps = {
  tenantPlanUpdateStore: TenantPlanUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantPlanUpdate: React.FC<TenantPlanUpdateProps> = observer(
  ({ tenantPlanUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={tenantPlanUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={tenantPlanUpdateStore.savedButOutdated}
          onReload={() => tenantPlanUpdateStore.reloadTenantPlan()}
          reloadDisabled={tenantPlanUpdateStore.isProcessing}
        />
        <TenantPlanUpdateForm
          tenantPlanUpdateStore={tenantPlanUpdateStore}
          name_esError={tenantPlanUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            tenantPlanUpdateStore.setName_esValue(value);
          }}
          name_es={tenantPlanUpdateStore.entityValues.name_es}
          name_enError={tenantPlanUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            tenantPlanUpdateStore.setName_enValue(value);
          }}
          name_en={tenantPlanUpdateStore.entityValues.name_en}
          name_ptError={tenantPlanUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            tenantPlanUpdateStore.setName_ptValue(value);
          }}
          name_pt={tenantPlanUpdateStore.entityValues.name_pt}
          description_esError={
            tenantPlanUpdateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            tenantPlanUpdateStore.setDescription_esValue(value);
          }}
          description_es={tenantPlanUpdateStore.entityValues.description_es}
          description_enError={
            tenantPlanUpdateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            tenantPlanUpdateStore.setDescription_enValue(value);
          }}
          description_en={tenantPlanUpdateStore.entityValues.description_en}
          description_ptError={
            tenantPlanUpdateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            tenantPlanUpdateStore.setDescription_ptValue(value);
          }}
          description_pt={tenantPlanUpdateStore.entityValues.description_pt}
          limitsError={tenantPlanUpdateStore.errors.limits?.message}
          onLimitsChange={(value: string) => {
            tenantPlanUpdateStore.setLimitsValue(value);
          }}
          limits={tenantPlanUpdateStore.entityValues.limits}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={tenantPlanUpdateStore.saveDisabled}
          onSave={() => tenantPlanUpdateStore.saveTenantPlan()}
          onCancel={() => tenantPlanUpdateStore.cancelTenantPlan()}
        />
        <ErrorDialog
          open={tenantPlanUpdateStore.errorDialogOpened}
          title={tenantPlanUpdateStore.errorTitle}
          description={tenantPlanUpdateStore.errorDescription}
          onClose={() => tenantPlanUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={tenantPlanUpdateStore.confirmDialogOpened}
          title={tenantPlanUpdateStore.confirmDialogTitle}
          description={tenantPlanUpdateStore.confirmDialogDescription}
          onConfirm={() => tenantPlanUpdateStore.executeConfirmedAction()}
          onCancel={() => tenantPlanUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
